import { Layout } from './layout';
import { Loading as LoadingContent } from './loading';

export function Loading() {
  return (
    <Layout>
      <LoadingContent />
    </Layout>
  );
}
